import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, getApi } from 'services/rotasp/api';
import { PATH_IIRGD_BU_PPT } from 'services/rotasp/path';

// STORE
import { ReducerActionRotaSP } from 'store/modules/types';

// ACTIONS
import {
	consultaDocumentosSuccess,
	consultaDocumentosFailure,
} from './actions';

// TYPES
import { Types } from './types';

function* consultaDocumentosRequest(request: ReducerActionRotaSP) {
	const { token, payload } = request;

	const response: ApiResponse = yield call(
		getApi,
		token || '',
		PATH_IIRGD_BU_PPT,
		`documentos/`,
		payload,
	);

	if (response.status === 200 || response.status === 201) {
		yield put(consultaDocumentosSuccess(response.data));
	} else if (response.error) {
		yield put(consultaDocumentosFailure());
	}
}

export default all([
	takeLatest(Types.CONSULTA_DOCUMENTOS_REQUEST, consultaDocumentosRequest),
]);
